var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "ui large form",
      class: { loading: _vm.form.waiting, warning: _vm.form.hasErrors() },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
    },
    [
      _c("app-message", { attrs: { msg: _vm.form.appMessage } }),
      _vm._v(" "),
      _vm.saved
        ? _c("div", { staticClass: "ui positive message" }, [
            _c("div", [_vm._v("保存しました")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.filledAll
        ? _c("div", { staticClass: "ui negative message" }, [
            _vm._v(
              "\n    お店とチャットを開始するには電話番号とお名前が必須となります。\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "six wide field required" },
          [
            _c("label", [_vm._v("メールアドレス")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.login_id,
                  expression: "form.model.login_id",
                },
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.form.model.login_id },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "login_id", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "login_id" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "six wide field required" },
          [
            _c("label", [_vm._v("電話番号")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.tel,
                  expression: "form.model.tel",
                },
              ],
              attrs: { type: "tel", placeholder: "080XXXXXXXX" },
              domProps: { value: _vm.form.model.tel },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "tel", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "tel" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "six wide required field" },
          [
            _c("label", [_vm._v("お名前(カナ)")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.name_kana,
                  expression: "form.model.name_kana",
                },
              ],
              attrs: { type: "text", placeholder: "お名前(カナ)" },
              domProps: { value: _vm.form.model.name_kana },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "name_kana", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "name_kana" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "ui submit button orange",
          class: { loading: _vm.form.waiting },
          attrs: { type: "submit" },
        },
        [_vm._v("保存する")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }